<template>
  <b-modal ref="modal-add-provider" hide-footer id="modal-add-provider">
    <template #modal-title>
      <h5 v-html="titleModal" class="mb-0"></h5>
    </template>
    <div class="mb-4">
      <b-form ref="form" class="row" @submit.prevent="onInternalSubmit">
        <b-container class="bv-example-row">
          <b-row>
            <b-col md="6">
              <div :style="textInfo">
                <p class="text-dark font-size-h5 font-weight-bold">
                  Thông tin cơ bản
                </p>
              </div>
            </b-col>
            <b-col md="6">
              <div :style="textInfo">
                <p class="text-dark font-size-h5 font-weight-bold">
                  Dành cho doanh nghiệp
                </p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group class="required-control">
                <label for="input-name">Tên nhà cung cấp:</label>
                <b-form-input
                  tabindex="1"
                  v-model.trim="formData.fullName"
                  placeholder="Nhập tên nhà cung cấp"
                  aria-describedby="input-name-live-feedback"
                  size="sm"
                />
                <b-form-invalid-feedback v-if="!formData.fullName"
                  >Vui lòng nhập tên nhà cung cấp!</b-form-invalid-feedback
                >
                <b-form-invalid-feedback v-if="!formData.fullName.length < 3"
                  >Nhập tên với ít nhất 3 kí tự!</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group class="required-control">
                <label for="input-code">Mã {{ 'doanh nghiệp' }}:</label>
                <b-form-input
                  tabindex="2"
                  v-model.trim="formData.code"
                  placeholder="Nhập mã nhà cung cấp"
                  aria-describedby="input-code-help"
                  size="sm"
                  :state="submitted && !formData.code ? false : null"
                />
                <b-form-invalid-feedback v-if="submitted && !formData.code"
                  >Vui lòng nhập mã KH/NCC!</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group class="required-control">
                <label>Loại khách hàng:</label>
                <b-form-select
                  size="sm"
                  v-model="formData.type"
                  :options="CUSTOMER_TYPE_OPTIONS"
                  class="select-style"
                  value-field="value"
                  text-field="text"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null"
                      >-- Chọn loại khách hàng/NCC --</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group class="required-control">
                <label for="input-mobile">Số điện thoại:</label>
                <b-form-input
                  tabindex="5"
                  v-model.trim="formData.phoneNo"
                  placeholder="Nhập số điện thoại"
                  aria-describedby="input-mobile-live-feedback"
                  size="sm"
                />
                <b-form-invalid-feedback v-if="!formData.phoneNo"
                  >Vui lòng nhập số điện thoại!</b-form-invalid-feedback
                >
                <b-form-invalid-feedback v-if="!formData.phoneNo.length < 9"
                  >Số điện thoại không hợp lệ!</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group class="required-control">
                <label for="input-tax-no">Mã số thuế:</label>
                <b-form-input
                  tabindex="6"
                  v-model.trim="formData.taxNo"
                  placeholder="Nhập Mã số thuế"
                  aria-describedby="input-tax-no-feedback"
                  size="sm"
                />
                <b-form-invalid-feedback v-if="!formData.taxNo"
                  >Yêu cầu mã số thuế!</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-overlay
            :show="isLoading"
            rounded
            opacity="0.6"
            class="d-inline-block mr-3"
            @hidden="$refs.button.focus()"
          >
            <template #overlay>
              <div class="d-flex align-items-center">
                <b-spinner variant="light" small type="grow"></b-spinner>
              </div>
            </template>
            <b-button
              :disabled="!formData.fullName.length"
              variant="primary"
              size="sm"
              @click="handleSubmit"
            >
              <v-icon small class="text-white" v-b-tooltip>mdi-download</v-icon>
              <strong>Lưu</strong>
            </b-button>
          </b-overlay>
          <b-button
            style="width: 80px"
            variant="secondary"
            size="sm"
            @click="$bvModal.hide('modal-add-provider')"
          >
            <strong>Hủy</strong>
          </b-button>
        </b-container>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { cloneDeep } from 'lodash';
import ProviderRepository from '@/repositories/ProviderRepository';
import CustomerRepository from '@/repositories/CustomerRepository';
import { makeToastFaile, makeToastSuccess } from '@/utils/common';
import { CUSTOMER_TYPE_OPTIONS } from '@/view/pages/customers/constants';

export default {
  data() {
    return {
      CUSTOMER_TYPE_OPTIONS,
      titleModal: 'Thêm nhanh nhà cung cấp',
      textInfo: {
        alignItems: 'center',
        display: 'flex',
        marginTop: '15px',
      },
      formData: {
        fullName: '',
        phoneNo: '',
        code: '',
        type: null,
        status: '1',
        taxNo: '',
      },
      isLoading: false,
      submitted: false,
    };
  },
  mixins: [validationMixin],
  methods: {
    async handleSubmit() {
      if (this.isLoading) return;
      this.submitted = true;
      if (!this.formData.fullName || !this.formData.code) return;

      const _formData = cloneDeep(this.formData);

      if (_formData) {
        this.isLoading = true;
        const payload = {
          ..._formData,
          status: 1,
        };

        delete payload.id; // Ensure no id is sent for create operation

        try {
          const response = await CustomerRepository.create(payload);
          makeToastSuccess(response.message || 'Thêm nhà cung cấp thành công!');
          this.$emit('onFetchProvider');
          this.$bvModal.hide('modal-add-provider');
        } catch (error) {
          console.error('Error creating provider:', error);
          const message =
            error?.response?.data?.message ||
            'Có lỗi xảy ra khi thêm nhà cung cấp.';
          makeToastFaile(message);
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
